import axios from 'axios';

import routes from 'app/routes';

export default {

  possibilitySchedule: (programId, callback) => {
    axios
      .get(routes.api.members.possibilityScheduleSession, {
        params: {
          program_id: programId,
        },
      })
      .then((resp) => {
        callback(resp.data.data);
      });
  },

  prepareSession: (step, params, successCallback, errorCallback) => {
    axios
      .post(routes.api.steps.session.prepareSession(step.id), { session: params })
      .then((resp) => {
        successCallback(resp.data.data);
      }).catch((resp) => {
        errorCallback(resp.response.data);
      });
  },

  getSession: (step, callback) => {
    axios
      .get(routes.api.steps.session.show(step.id))
      .then((resp) => {
        callback(resp.data.data);
      });
  },

  schedule: (step, params, successCallback, errorCallback) => {
    axios
      .post(routes.api.steps.session.create(step.id), { session: params })
      .then((_resp) => {
        successCallback();
      }).catch((resp) => {
        errorCallback(resp.response.data);
      });
  },

  reschedule: (step, params, successCallback, errorCallback) => {
    axios
      .put(routes.api.steps.session.update(step.id), { session: params })
      .then((_resp) => {
        successCallback();
      }).catch((resp) => {
        errorCallback(resp.response.data);
      });
  },

  cancelType: (step, callback) => {
    axios
      .post(routes.api.steps.session.cancelType(step.id))
      .then((resp) => {
        callback(resp.data);
      });
  },

  cancel: (step, successCallback, errorCallback) => {
    axios
      .delete(routes.api.steps.session.cancel(step.id))
      .then((resp) => {
        successCallback(resp.data.data);
      }).catch((resp) => {
        errorCallback(resp.response.data);
      });
  },

  skipSession: (stepId, successCallback, errorCallback) => {
    axios
      .post(routes.api.steps.skipSession(stepId))
      .then((resp) => {
        successCallback(resp.data.data);
      }).catch((resp) => {
        errorCallback(resp.response.data);
      });
  },

  confirmSession: (stepId, successCallback) => {
    axios
      .post(routes.api.steps.confirm(stepId))
      .then((resp) => {
        successCallback(resp.data.data);
      });
  },

  completeStep: (stepId, callback) => {
    axios
      .post(routes.api.members.steps.complete(stepId))
      .then((resp) => {
        callback(resp.data.data);
      });
  },

};
